import { render } from "./AddRecipeModal.vue?vue&type=template&id=2f058d72&ts=true"
import script from "./AddRecipeModal.vue?vue&type=script&lang=ts"
export * from "./AddRecipeModal.vue?vue&type=script&lang=ts"

import "./AddRecipeModal.vue?vue&type=style&index=0&id=2f058d72&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__